const devPlatform = (data, gsap, mm, ScrollTrigger, smoother, MotionPathPlugin, DrawSVGPlugin) => {
		
	const $body = $('body');
	const $header = $('#header');
	const $data = $(data.next.container);
	const $capMobile = $data.find('.cap-bg-mobile');
	const $capMobileImg = $data.find('.cap-bg-mobile img');
	const lines = $data.find('.line-group');
	const capCards = $data.find('.dp-capabilities-card');
	const $capModal = $('.dp-modal-transplant').detach();
	const $capModalInner = $capModal.find('.dp-modal');
	const $capModalMask = $capModal.find('.exit-modal');
	const $capModalContent = $capModal.find('.modal-content');
	const $capModalTarget = $capModal.find('.transplant-content');
	const $capModalClose = $capModal.find('.close');
	const $portal = $data.find('.portal-illo');
	const $portalLines = $portal.find('.dp-lines .lines > path');
	const $portalDots = $portal.find('.dp-lines .dot');
	const $portalCards = $portal.find('.cards .card');
	$body.append($capModal);
	
	mm.add("(min-width: 62rem)", () => {
		
		lines.each(function() {

			const $this = $(this);
			const line = $this.find('path').get(0);
			const dot = $this.find('circle');
			const dotTl = gsap.timeline({repeat: -1, yoyo: true});
			
			dotTl.to(dot, {duration: 0.5, opacity: 0.5, repeat: -1, yoyo: true})
					 .to(dot, {
							duration: 6,
							ease: "none",
							delay: "random(0, 8)",
							repeat: -1, 
							yoyo: true,
							motionPath:{
								path: line,
								align: line,
								alignOrigin: [0.5, 0.5]
							}
					 }, "<");

			dotTl.play();

		});
		
	}, '.page-template-page-dev-platform');
	
	mm.add("(max-width: 61rem)", () => {
		
		if ($capMobile.length) {
			ScrollTrigger.create({
				trigger: $capMobile,
				pin: $capMobileImg,
				start: "top top-=120px",
				end: "bottom bottom"
			});
		}

	}, '.page-template-page-dev-platform');
	
	capCards.each(function() {
		
		const $this = $(this);
		const modalContent = $this.find('.modal-content').html();
		
		
		$this.on('click', function(e) {
			e.preventDefault();
			$capModalTarget.html(modalContent);
			$header.addClass('modal-open');
			$capModalInner.addClass('active');
			setTimeout(() => {
				gsap.to($capModalMask, {duration: 0.3, opacity: 0.75});
				gsap.to($capModalContent, {duration: 0.6, x: 0});
				smoother.paused(true);
				//ScrollTrigger.refresh();
			}, 300);
		});
		
	});
	
	$capModalClose.each(function() {
		
		const $this = $(this);
		
		$this.on('click', function(e) {
			e.preventDefault();
			gsap.to($capModalContent, {duration: 0.6, x: '100%'});
			gsap.to($capModalMask, {duration: 0.3, opacity: 0, onComplete: () => {
				setTimeout(() => {
					$capModalInner.removeClass('active');
					$header.removeClass('modal-open');
					$capModalTarget.empty();
					smoother.paused(false);
					ScrollTrigger.refresh();
				}, 600);
			}});
		});
		
	});
	
	if ($portalLines.length) {
		$portalLines.each(function() {
			const $this = $(this);
			const lineTL = gsap.timeline({repeat: -1, yoyo: true});
			lineTL.from($this, {duration:3, delay: "random(0, 3)", drawSVG: 0});
		});
	}
	
	if ($portalDots.length) {
		$portalDots.each(function(i) {
			const $this = $(this);
			const line = $this.find('path').get(0);
			const dot = $this.find('circle');
			
			const lineTL = gsap.timeline({repeat: -1, yoyo: true});
			lineTL.from(line, {
				duration:6,
				ease: "none",
				//delay: i, 
				drawSVG: 0});
			
			const dotTl = gsap.timeline({repeat: -1, yoyo: true});

			dotTl.to(dot, {duration: 0.5, opacity: 0.5, repeat: -1, yoyo: true})
					 .to(dot, {
					 	 duration: 6,
						 ease: "none",
						 //delay: i,
						 repeat: -1, 
						 yoyo: true,
						 motionPath:{
							 path: line,
							 align: line,
							 alignOrigin: [0.5, 0.5]
						 }
					 }, "<");

			dotTl.play();

		});
	}
	
	if ($portalCards.length) {
		$portalCards.each(function() {
			const $this = $(this);
			
			if ($this.hasClass('card-1')) {
				gsap.fromTo($this, {
					y: "-20%"
				}, {
					y: 0, 
					duration: 1, 
					scrollTrigger: {
						trigger: $portal, 
						start: "top 80%", 
						end: "bottom 70%", 
						scrub: true,
					}
				});
			} else if ($this.hasClass('card-2')) {
				gsap.set($this, {y: "20%"});
				gsap.fromTo($this, {
					y: "20%"
				}, {
					y: 0, 
					duration: 1, 
					scrollTrigger: {
						trigger: $portal, 
						start: "top 80%", 
						end: "bottom 70%", 
						scrub: true,
					}
				});
			} else if ($this.hasClass('card-3')) {
				const cardTL = gsap.timeline({
					yoyo: true,
					scrollTrigger: {
						trigger: $portal,
						start: "top 35%",
					},
					onComplete: () => {
						cardTL.reverse();
					}
				});
				cardTL.to($this, {
					duration: 0.6,
					filter: 'brightness(1.5)',
					scale: 1.05,
					ease: "none",
					transformOrigin: 'center center'
				});
			}
			
		});
	}

}

export {
	devPlatform
};
